<template>
  <b-container fluid>
    <page-title :icon="'fas fa-' + ecosystemModules.items.menuIcon || ecosystemModules.items.icon.type">
      {{ecosystemModules.items.label || $gettext('Items')}}
    </page-title>
    <api-list type="items" :model="models.items" :quick-filters="quickFiltersSetup.items" />

    <items-shared />
  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'
import ItemsShared from '@/components/Items/Shared'

export default {
  name: 'ItemsList',
  title() {
    return this.ecosystemModules.items.label || this.$gettext('Items')
  },
  components: {
    ApiList,
    ItemsShared
  }
}
</script>
